
























































import { Component, Vue } from 'vue-property-decorator';
import { formatDateWithMonthName } from '@/helpers/dateFormatter';
import { InvoiceReport } from '@/interfaces/InvoiceReport';
import { Action } from 'vuex-class';

@Component({
    name: 'AccountInvoices',
})
export default class AccountInvoices extends Vue {

    @Action('user/downloadInvoice') public downloadInvoice!: (id: number) => Promise<string>;

    protected get invoices() {
        return this.$store.getters['user/invoices'];
    }

    protected idsBeingDownloaded: number[] = [];

    protected formattedDate(dateTimestamp: string) {
        return formatDateWithMonthName(dateTimestamp);
    }

    protected sortMethod(a: InvoiceReport, b: InvoiceReport) {
        const firstDate = +new Date(a.createdAt);
        const secondDate = +new Date(b.createdAt);
        return firstDate - secondDate;
    }

    protected navigateToComponent(componentName: string) {
        this.$emit('navigate', componentName);
    }

    protected async onDownload(id: number) {
        this.$message.info('Generating receipt, please wait.');
        const invoiceItem = this.invoices.filter((invoice: InvoiceReport) => id === invoice.id);
        if (!invoiceItem.length) {
            this.$message.error('There was an error, please try again.');
            return;
        }
        this.idsBeingDownloaded.push(id);
        const blob = await this.decodePDF(id);
        const name = 'Invoice for order #' + invoiceItem[0].invoiceNumber + '.pdf';
        this.fileSaver(blob, name);
        this.idsBeingDownloaded.splice(this.idsBeingDownloaded.indexOf(id), 1);
    }

    protected async decodePDF(id: number) {
        const invoice = await this.downloadInvoice(id);
        const byteCharacters = atob(invoice);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: 'application/pdf'});
    }

    protected fileSaver(blob: Blob, name: string) {
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, name);
            return;
        } else if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, name);
            return;
        }
        link.href = data;
        link.download = name;
        document.body.appendChild(link);
        link.click();
    }
}
